// extracted by mini-css-extract-plugin
export default {"container":"or-z","heading":"pr-z","text":"qr-z","info":"rr-z","link":"sr-z","fullMaxWidth":"tr-z"};